import { useGetTiCardData } from "../../../../search/components/ticard/hooks";
import ThreatInfo from "./ThreatInfo";

type Props = {
  name: string;
};

const ThreatInfoCard = ({ name }: Props) => {
  const { data } = useGetTiCardData(name);

  const actors = data?.rl?.general?.actor?.map(item => item.name);

  return <ThreatInfo actors={actors ?? []} name={name} withSearchLinks />;
};

export default ThreatInfoCard;
